import {BottomNavigationBarMenuItemsListDefaultBox} from "./bottom-navigation-bar-menu-items-list.default.box";

export const BottomNavigationBarMenuItemsListBox = BottomNavigationBarMenuItemsListDefaultBox;
